import Vue from 'vue'

import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import LandingPage from '@/views/LandingPage.vue'
import Fq from '@/views/Fq'
import VetView from '@/views/Veterinaries'
import store from '@/store'
import authRoutes from './auth'
import petRoutes from './pets'
import adminRoutes from './admin'
import userRoutes from './user'


Vue.use(VueRouter);

let baseRoutes = [
  {
    path: '*',
    name: 'index',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/faqs',
    name: 'faq',
    component: Fq,
    meta: {
      title: 'Preguntas frecuentes',
      requiresAuth: false,
      requiresObipetsAdmin: false
    }
  },
  {
    path: '/', 
    name: 'landingPage',
    component: LandingPage,
    meta: {
      title: 'Obipets',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
  path: '/veterinariasnull',
    name: 'veterinarias',
    component: VetView,
    meta: {
      title: 'Veterinarias',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
];

// noinspection JSCheckFunctionSignatures
const routes = baseRoutes
  .concat(
    petRoutes,
    adminRoutes,
    userRoutes,
    authRoutes
  );


const router = new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0
    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }
    return goTo(scrollTo)
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresObipetsAdmin = to.matched.some(record => record.meta.requiresObipetsAdmin);
  const isLogged = store.getters['auth/isLogged'];
  const isObipetsAdmin = store.getters['auth/isObipetsAdmin'];

  if (!requiresAuth && isLogged && to.path === '/login') {
    next({ name: 'userDash' })
  }
  if (requiresAuth && !isLogged) {
    next({ name: 'login' })
  } else {
    next()
  }
  if(requiresObipetsAdmin && !isObipetsAdmin) {
    next({ name: 'login' })
  } else {
    next()
  }
});

export default router
